import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { faArrowRight, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, CardActionArea, CardActions, CardContent, Grid, makeStyles, Typography } from '@material-ui/core';
// import { CommonConfig } from '../../config/common-config'
// import axios from 'axios';
// import ServiceTable from  '../../modules/services/view/Table/table'

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paperUltimate: {
        padding: theme.spacing(4),
        textAlign: 'left',
        color: '#fff',
        backgroundColor: '#4C516D',
        borderRadius: '8px',
    },
    intMainDiv: {
        padding: theme.spacing(0),
        textAlign: 'left',
    },
    clientHeading: {
        color: '#fff',
        fontSize: '16px',
        fontFamily: 'Lato',
        fontWeight: '700',
    },
    fontSizeColor: {
        fontSize: '12px',
        color: '#fff',
        marginLeft: '4px',
    },
    moreLink: {
        fontSize: '12px',
        fontFamily: 'Lato',
        margin: '20px 0px',
        cursor: 'pointer',
    },
}));

function NewCard(props) {
    const classes = useStyles();
    const history = useHistory();
    const { title, nameCard } = props;
    // const [dataOpen, setDataOpen] = useState([]);

    const navigate = () => {
        if (nameCard === 'create') {
            history.push('/menu/service');
        }
        if (nameCard === 'open') {
            history.push('/menu/openservice');
        }
        if (nameCard === 'closed') {
            history.push('/menu/closedservice');
        }
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={12}>
                    <Card className={classes.paperUltimate} onClick={navigate}>
                        <CardActionArea>
                            <CardContent className={classes.intMainDiv}>
                                <Typography variant="subtitle1" display="block" gutterBottom className={classes.clientHeading}>
                                    {title}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                        <CardActions>
                            <Grid container spacing={2}>
                                <Grid item xs={8}>
                                    <div>
                                        <FontAwesomeIcon icon={faUser} size="4x" className={classes.colorFnt} />
                                    </div>
                                    <div>
                                        <Typography
                                            className={classes.moreLink}
                                            variant="button"
                                            display="block"
                                            gutterBottom
                                            // onClick={navigate}
                                        >
                                            More
                                            <FontAwesomeIcon icon={faArrowRight} className={classes.fontSizeColor} />
                                        </Typography>
                                    </div>
                                </Grid>
                            </Grid>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
}

export default NewCard;
